import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Image, Form, InputGroup, Dropdown, DropdownButton, Row, Col } from 'react-bootstrap';
import ManagerService from '../../services/ManagerService';
import LoadThongTinService from '../../services/LoadThongTinService';
import EditModal from './ChinhSuaTTChuyenKDComponent';
import './style.css';

const ChuyenKinhDoanh = () => {
    const [data, setData] = useState([]);
    const [columns, setColumns] = useState([]);
    const [visibleColumns, setVisibleColumns] = useState([]); // Cột được chọn để hiển thị
    const [visibleColumnsPreview, setVisibleColumnsPreview] = useState([]); // Bản xem trước của cột được chọn
    const [searchColumns, setSearchColumns] = useState([{ value: 'id', label: 'Mã chuyến' }, { value: 'ten_khach_hang', label: 'Tên khách hàng' }, { value: 'ngay_van_chuyen', label: 'Ngày vận chuyển' }]);
    const [searchParams, setSearchParams] = useState({});
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(50);
    const [totalPages, setTotalPages] = useState(0);
    const [showImageModal, setShowImageModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false); // Quản lý trạng thái modal
    const [selectedRow, setSelectedRow] = useState(null); // Dữ liệu của dòng được chọn
    const [customers, setCustomers] = useState([]);
    const [updatedRow, setUpdatedRow] = useState(null); // Lưu dữ liệu sau khi chỉnh sửa
    const [showEndModal, setShowEndModal] = useState(false); // Quản lý trạng thái modal kết thúc
    const [endRowData, setEndRowData] = useState(null); // Dữ liệu chuyến cần kết thúc
    const [uploadedImage, setUploadedImage] = useState(null); // Quản lý ảnh đã upload

    // Danh sách các cột có thể chỉnh sửa
    const editableColumns = [
        'ten_khach_hang',
        'ngay_van_chuyen',
        'loai_xe',
        'trong_tai',
        'so_luong_chuyen',
        'don_vi_tinh',
        'phu_phi',
        'chi_phi_thuc_hien',
        'ghi_chu',
        'gia_ban',
        'diem_di_thuc_te',
        'diem_den_thuc_te',
        'loai_van_chuyen',
        'chi_phi_thue',
        'bien_ban_giao_hang',
    ];


    const editableBackendColumns = [
        'ten_khach_hang',
        'ngay_van_chuyen',
        'diem_di',
        'diem_den',
        'loai_xe',
        'trong_tai',
        'so_luong_chuyen',
        'don_vi_tinh',
        'phu_phi',
        'chi_phi_thuc_hien',
        'ghi_chu',
        'gia_ban',
        'diem_di_thuc_te',
        'diem_den_thuc_te',
        'loai_chay',
        'loai_van_chuyen',
        'chi_phi_thue',
        'bien_ban_giao_hang',
    ];

    // Hàm gọi API VietMap để tìm kiếm gợi ý
    const loadOptions = async (inputValue, field) => {
        if (!inputValue) return []; // Không gọi API nếu không có giá trị đầu vào

        const apiKey = 'babc2659cbd0eb4a1ad8598481c3b003bc94d70196e42c41';
        const url = `https://maps.vietmap.vn/api/autocomplete/v3?apikey=${apiKey}&text=${encodeURIComponent(inputValue)}`;

        try {
            const response = await fetch(url);
            const data = await response.json();
            return data.map((item) => ({
                label: item.display, // Hiển thị gợi ý với thuộc tính display
                mainValue: item.boundaries[2]?.name || '',
                displayValue: item.display || '',
            }));
        } catch (error) {
            console.error(`Lỗi khi gọi API autocomplete cho ${field}:`, error);
            return [];
        }
    };

    // Lấy dữ liệu từ API
    const fetchData = async (params = {}) => {
        try {
            const response = await ManagerService.getChuyenKinhDoanh({
                ...params,
                page_number: pageNumber,
                page_size: pageSize,
            });
            setData(response.data || []);
            setColumns(response.columns || []); // Mảng object chứa {label, value}
            setVisibleColumns(response.columns.map((col) => col.value) || []); // Hiển thị tất cả cột mặc định
            setVisibleColumnsPreview(response.columns.map((col) => col.value) || []); // Đồng bộ bản xem trước
            setTotalPages(response.total_pages || 0);
        } catch (error) {
            console.error('Lỗi khi lấy dữ liệu:', error.message);
        }
    };

    // Xử lý tìm kiếm
    const handleSearch = () => {
        fetchData(searchParams);
    };

    // Đóng modal hiển thị ảnh
    const handleCloseImageModal = () => {
        setShowImageModal(false);
        setSelectedImage(null);
    };

    // Xử lý chuyển trang
    const handlePageChange = (newPageNumber) => {
        setPageNumber(newPageNumber);
        fetchData(searchParams);
    };

    // Chọn hoặc bỏ chọn một cột trong bản xem trước
    const toggleColumnVisibilityPreview = (columnValue) => {
        setVisibleColumnsPreview((prev) =>
            prev.includes(columnValue)
                ? prev.filter((col) => col !== columnValue) // Bỏ cột
                : [...prev, columnValue] // Thêm cột
        );
    };

    // Xác nhận thay đổi cột hiển thị
    const applyColumnVisibilityChanges = () => {
        setVisibleColumns([...visibleColumnsPreview]);
    };

    const showTooltip = (e, content) => {
        const tooltip = document.getElementById('tooltip');
        tooltip.innerHTML = content || 'Không có dữ liệu';
        tooltip.style.display = 'block';
        tooltip.style.top = `${e.clientY + 10}px`;
        tooltip.style.left = `${e.clientX + 10}px`;
    };

    const hideTooltip = () => {
        const tooltip = document.getElementById('tooltip');
        tooltip.style.display = 'none';
    };

    const handleShowEditModal = (row) => {
        setSelectedRow(row); // Lưu trữ dữ liệu ban đầu để so sánh khi lưu
        setUpdatedRow({ ...row }); // Tạo một bản sao để chỉnh sửa
        setShowEditModal(true);
    };

    const handleCloseEditModal = () => {
        setShowEditModal(false);
        setSelectedRow(null);
    };

    const handleSaveEdit = async () => {
        if (!selectedRow) return;

        // So sánh dữ liệu ban đầu và dữ liệu đã chỉnh sửa
        const dataUpdated = {};
        for (const key of Object.keys(selectedRow)) {
            if (editableBackendColumns.includes(key) && selectedRow[key] !== updatedRow[key]) {
                dataUpdated[key] = updatedRow[key];
            }
        }

        // Kiểm tra nếu không có trường nào thay đổi
        if (Object.keys(dataUpdated).length === 0) {
            alert('Không có thay đổi nào được thực hiện.');
            setShowEditModal(false);
            return;
        }

        // Thêm ID vào dữ liệu cập nhật
        dataUpdated.id = selectedRow.id;

        try {
            // Gửi yêu cầu cập nhật đến API thông qua ManagerService
            const response = await ManagerService.updateThongTinChuyenKD(dataUpdated);

            if (response.success) {
                alert('Cập nhật thành công!');
                setShowEditModal(false); // Đóng modal
                setSelectedRow(null);
                fetchData(); // Tải lại dữ liệu sau khi cập nhật
            } else {
                alert(`Cập nhật thất bại: ${response.message}`);
            }
        } catch (error) {
            console.error('Lỗi khi cập nhật thông tin chuyến KD:', error);
            alert('Đã xảy ra lỗi khi cập nhật thông tin. Vui lòng thử lại.');
        }
    };

    const handleEndTrip = (row) => {
        const validTypes = ['Xe Thuê Ngoài', 'Container Tài Hoả', 'Container Tàu Thuỷ', 'FWD'];
        if (validTypes.includes(row.loai_van_chuyen)) {
            if (!row.bien_ban_giao_hang) {
                setEndRowData(row);
                setShowEndModal(true);
            }
            else {
                alert('Bạn đã kết thúc chuyến xe này rồi, nếu cần chỉnh sửa biên bản giao hàng hãy cập nhật ở phần Sửa!');
            }
            
        } else {
            alert('Bạn chỉ có thể kết thúc các chuyến xe thuê ngoài!');
        }
    };


    const handleCloseEndModal = () => {
        setShowEndModal(false);
        setEndRowData(null);
        setUploadedImage(null);
    };

    // Xử lý upload ảnh và chuyển sang base64
    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setUploadedImage(reader.result); // Base64 của ảnh
            };
            reader.readAsDataURL(file);
        }
    };

    const handleConfirmEndTrip = async () => {
        if (!uploadedImage) {
            alert('Vui lòng tải lên ảnh biên bản giao hàng!');
            return;
        }

        if (!endRowData?.id) {
            alert('Thiếu thông tin mã chuyến để kết thúc!');
            return;
        }

        const dataToUpdate = {
            id: endRowData.id, // Chỉ lấy id
            bien_ban_giao_hang: uploadedImage, // Ảnh dưới dạng base64
        };

        try {
            const response = await ManagerService.updateThongTinChuyenKD(dataToUpdate);
            if (response.success) {
                alert('Chuyến xe đã được kết thúc thành công!');
                fetchData(); // Cập nhật lại danh sách chuyến xe
                handleCloseEndModal();
            } else {
                alert(response.message || 'Không thể kết thúc chuyến xe.');
            }
        } catch (error) {
            alert(error.message || 'Đã xảy ra lỗi khi kết thúc chuyến xe.');
        }
    };

    const handleShowImageModal = (imageData) => {
        setSelectedImage(imageData); // Chuyển đổi sang base64 nếu cần
        setShowImageModal(true); // Hiển thị modal
    };


    useEffect(() => {
        const fetchCustomers = async () => {
            try {
                const response = await LoadThongTinService.getKhachHang();
                const customerOptions = response.data.map((customer) => ({
                    value: customer,
                    label: customer,
                }));
                setCustomers(customerOptions);
            } catch (error) {
                console.error('Lỗi khi tải danh sách khách hàng:', error);
                setCustomers([]);
            }
        };
        fetchCustomers();
    }, []);

    // Lấy dữ liệu ban đầu
    useEffect(() => {
        fetchData();
    }, [pageNumber]);

    return (
        <div className="container mt-4" id="trang_thai_chuyen_kd">
            <h2>Danh sách chuyến kinh doanh</h2>

            {/* Tìm kiếm */}
            <InputGroup className="mb-3">
                {searchColumns.map((col) => (
                    <Form.Control
                        key={col.value}
                        placeholder={`Tìm kiếm ${col.label}`}
                        value={searchParams[col.value] || ''}
                        onChange={(e) => setSearchParams({ ...searchParams, [col.value]: e.target.value })}
                    />
                ))}
                <Button variant="primary" onClick={handleSearch} className='custom-btn'>
                    Tìm kiếm
                </Button>
            </InputGroup>

            {/* Chọn cột hiển thị */}
            <DropdownButton title="Chọn cột hiển thị" className="mb-3 custom-btn" autoClose="outside">
                {/* Chọn tất cả */}
                <Dropdown.Item
                    onClick={(e) => {
                        e.preventDefault(); // Ngăn dropdown bị đóng
                        setVisibleColumnsPreview(columns.map((col) => col.value));
                    }}
                >
                    <Form.Check
                        type="checkbox"
                        label="Chọn tất cả"
                        checked={visibleColumnsPreview.length === columns.length}
                        onChange={(e) => {
                            e.preventDefault(); // Ngăn checkbox kích hoạt hành vi mặc định
                            setVisibleColumnsPreview(columns.map((col) => col.value));
                        }}
                    />
                </Dropdown.Item>

                {/* Bỏ chọn tất cả */}
                <Dropdown.Item
                    onClick={(e) => {
                        setVisibleColumnsPreview([]);
                    }}
                >
                    <Form.Check
                        type="checkbox"
                        label="Bỏ chọn tất cả"
                        checked={visibleColumnsPreview.length === 0}
                        onChange={(e) => {
                            setVisibleColumnsPreview([]);
                        }}
                    />
                </Dropdown.Item>

                <Dropdown.Divider />

                {/* Hiển thị các cột */}
                {columns.map((col) => (
                    <Dropdown.Item
                        key={col.value}
                        onClick={(e) => {
                            e.preventDefault(); // Ngăn dropdown bị đóng
                            toggleColumnVisibilityPreview(col.value);
                        }}
                    >
                        <Form.Check
                            type="checkbox"
                            label={col.label} // Sử dụng label (tiếng Việt có dấu)
                            checked={visibleColumnsPreview.includes(col.value)}
                            onChange={(e) => {
                                e.preventDefault(); // Ngăn checkbox kích hoạt hành vi mặc định
                                toggleColumnVisibilityPreview(col.value);
                            }}
                        />
                    </Dropdown.Item>
                ))}

                <Dropdown.Divider />

                {/* Nút xác nhận */}
                <Dropdown.Item>
                    <Button
                        variant="primary"
                        className="w-100"
                        onClick={applyColumnVisibilityChanges}
                    >
                        Xác nhận
                    </Button>
                </Dropdown.Item>
            </DropdownButton>

            {/* Bảng hiển thị */}
<Table striped bordered hover responsive style={{ fontSize: '13px', position: 'relative' }}>
    <thead>
        <tr>
            {columns.map((col) =>
                visibleColumns.includes(col.value) ? (
                    <th key={col.value}>{col.label}</th> // Hiển thị label
                ) : null
            )}
            <th>Hành động</th>
        </tr>
    </thead>
    <tbody>
        {data.map((item, index) => (
            <tr key={index}>
                {columns.map((col) =>
                    visibleColumns.includes(col.value) ? (
                        <td
                            key={`${index}-${col.value}`}
                            className="table-cell"
                            onMouseEnter={(e) => showTooltip(e, item[col.value])} // Tra cứu theo value
                            onMouseLeave={hideTooltip}
                        >
                            {/* Hiển thị "Xem chi tiết" nếu là cột bien_ban_giao_hang và có giá trị */}
                            {col.value === 'bien_ban_giao_hang' && item[col.value] ? (
                                <span
                                    className="text-primary cursor-pointer"
                                    onClick={() => handleShowImageModal(item[col.value])} // Gọi hàm mở modal
                                >
                                    Xem chi tiết
                                </span>
                            ) : (
                                item[col.value] || '' // Hiển thị giá trị thông thường
                            )}
                        </td>
                    ) : null
                )}
                <td className="table-cell-button">
                    <Button
                        variant="warning"
                        size="sm"
                        className="me-2 custom-btn"
                        onClick={() => handleShowEditModal(item)}
                    >
                        Sửa
                    </Button>
                    <Button
                        variant="success"
                        size="sm"
                        className="custom-btn"
                        onClick={() => handleEndTrip(item)} // Chỉ truyền id
                    >
                        Kết thúc
                    </Button>
                </td>
            </tr>
        ))}
    </tbody>
</Table>

            {/* Tooltip */}
            <div id="tooltip" style={{ display: 'none', position: 'absolute', zIndex: 1000 }}></div>

            {/* Phân trang */}
            <div className="d-flex justify-content-between align-items-center mt-3">
                <Button
                    variant="secondary"
                    disabled={pageNumber === 1}
                    onClick={() => handlePageChange(pageNumber - 1)}
                >
                    Trang trước
                </Button>
                <span style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                    Trang {pageNumber} / {totalPages}
                </span>
                <Button
                    variant="secondary"
                    disabled={pageNumber === totalPages}
                    onClick={() => handlePageChange(pageNumber + 1)}
                >
                    Trang sau
                </Button>
            </div>

            {/* Modal kết thúc chuyến xe */}
            <Modal show={showEndModal} onHide={handleCloseEndModal} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Kết thúc chuyến xe</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {endRowData && (
                        <>
                            <Form>
                                <Row className="mb-3">
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Mã chuyến</Form.Label>
                                            <Form.Control type="text" value={endRowData.id || ''} readOnly />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Tên khách hàng</Form.Label>
                                            <Form.Control type="text" value={endRowData.ten_khach_hang || ''} readOnly />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Loại vận chuyển</Form.Label>
                                            <Form.Control type="text" value={endRowData.loai_van_chuyen || ''} readOnly />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Ngày vận chuyển</Form.Label>
                                            <Form.Control type="text" value={endRowData.ngay_van_chuyen || ''} readOnly />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Tài xế</Form.Label>
                                            <Form.Control type="text" value={endRowData.tai_xe || ''} readOnly />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Biển kiểm soát</Form.Label>
                                            <Form.Control type="text" value={endRowData.bien_kiem_soat || ''} readOnly />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Upload ảnh biên bản giao hàng</Form.Label>
                                            <Form.Control type="file" accept="image/*" onChange={handleImageUpload} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Form>
                            {uploadedImage && (
                                <div className="text-center mt-3">
                                    <p>Ảnh đã tải lên:</p>
                                    <img src={uploadedImage} alt="Biên bản giao hàng" style={{ maxWidth: '100%' }} />
                                </div>
                            )}
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseEndModal}>
                        Đóng
                    </Button>
                    <Button variant="primary" onClick={handleConfirmEndTrip}>
                        Xác nhận kết thúc
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal hiển thị ảnh */}
            <Modal show={showImageModal} onHide={handleCloseImageModal} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Ảnh Biên Bản Giao Hàng</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedImage && <Image src={selectedImage} fluid />}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseImageModal}>
                        Đóng
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal sửa thông tin */}
            <EditModal
                show={showEditModal}
                onClose={handleCloseEditModal}
                columns={columns}
                rowData={updatedRow || selectedRow}
                setRowData={setUpdatedRow}
                onSave={handleSaveEdit}
                editableColumns={editableColumns}
                loadOptions={loadOptions}
                customerOptions={customers}
            />
        </div>
    );
};

export default ChuyenKinhDoanh;
